import type { ChangelogStore } from './interfaces'

const isSameSource = (left: ChangelogStore['listSource'], right: ChangelogStore['listSource']): boolean =>
  JSON.stringify(left) === JSON.stringify(right)

export const actions = {
  /** Switching to another list drops the previous one's rows so they never flash under the new page. */
  setListSource (this: ChangelogStore, payload: ChangelogStore['listSource']): void {
    if (isSameSource(this.listSource, payload)) return

    this.listSource = payload
    this.actions = []
    this.meta = null
    this.expandedActionId = null
    this.items = []
    this.detailItem = null
  },
  setDetailItem (this: ChangelogStore, payload: ChangelogStore['detailItem']): void {
    this.detailItem = payload
  },
  setLoading (this: ChangelogStore, payload: ChangelogStore['loading']): void {
    this.loading = payload
  },
  setActions (this: ChangelogStore, payload: ChangelogStore['actions']): void {
    this.actions = payload
  },
  setMeta (this: ChangelogStore, payload: ChangelogStore['meta']): void {
    this.meta = payload
  },
  setFilterSearch (this: ChangelogStore, payload: ChangelogStore['filterSearch']): void {
    this.filterSearch = payload
  },
  setFilterFrom (this: ChangelogStore, payload: ChangelogStore['filterFrom']): void {
    this.filterFrom = payload
  },
  setFilterTo (this: ChangelogStore, payload: ChangelogStore['filterTo']): void {
    this.filterTo = payload
  },
  setPerPage (this: ChangelogStore, payload: ChangelogStore['perPage']): void {
    this.perPage = payload
  },
  setCursor (this: ChangelogStore, payload: ChangelogStore['cursor']): void {
    this.cursor = payload
  },
  setExpandedActionId (this: ChangelogStore, payload: ChangelogStore['expandedActionId']): void {
    this.expandedActionId = payload
  },
  setItems (this: ChangelogStore, payload: ChangelogStore['items']): void {
    this.items = payload
  },
  setItemsLoading (this: ChangelogStore, payload: ChangelogStore['itemsLoading']): void {
    this.itemsLoading = payload
  },
  resetFilters (this: ChangelogStore): void {
    this.filterSearch = null
    this.filterFrom = null
    this.filterTo = null
    this.cursor = null
  },
  /** The list answer goes with the page it was read for: the next visit starts empty, under its loader, never
   *  showing stale rows until its own land. Filters and paging stay. */
  resetList (this: ChangelogStore): void {
    this.actions = []
    this.meta = null
    this.expandedActionId = null
    this.items = []
    this.detailItem = null
  },
}
